/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _style = __webpack_require__(1);

var _style2 = _interopRequireDefault(_style);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

document.onreadystatechange = function () {
	'use strict';

	function showOverlay() {
		var overlay = document.createElement("DIV");
		document.body.insertBefore(overlay, document.body.childNodes[0]);
		overlay.classList.add('overlay');
		document.body.style.overflow = 'hidden';
	}

	function hideOverlay() {
		var overlay = document.querySelector('.overlay');
		overlay.remove();
		document.body.style.overflowY = 'auto';
	}

	function addElement(dataName, dataObj, ind, param) {
		if (dataName == 'head') {
			return '\n\t\t\t\t<div class="modal-head">\n            \t\t<h2>' + param + '</h2>\n         \t\t</div>\n\t\t\t';
		}
		if (dataName == 'foot') {
			if (param) {
				return '<div class="modal-foot">\n\t\t\t\t\t  <a class="btn btn-blue" target="_blank" href="' + param + '">View Demo</a>\n\t\t\t\t\t  <button class="btn btn-red modal-close">Close</button>\n\t\t\t\t\t</div>';
			} else {
				return '<div class="modal-foot">\n\t\t\t\t\t  <button class="btn btn-red modal-close">Close</button>\n\t\t\t\t\t</div>';
			}
		}
	}

	function gitData(data) {
		return '\n\t\t\t<div class="col-6">\n\t\t\t\t<img class="img-fluid" src="' + data.avatar_url + '" />\n\t\t\t</div>\n\t\t\t<div class="col-6">\n\t\t\t\t<div class="card-heading">' + data.name + '</div>\n\t\t\t\t<p class="mb-10">Title : <span style="color: black">' + data.bio + '</span></p>\n\t\t\t\t<p class="mb-10">Repositories : <span style="color: black">' + data.public_repos + '</span></p>\n\t\t\t\t<p class="mb-10">Gists : <span style="color: black">' + data.public_gists + '</span></p>\n\t\t\t\t<p class="mb-10">Followers : <span style="color: black">' + data.followers + '</span></p>\n\t\t\t\t<p class="mb-10">Following : <span style="color: black">' + data.following + '</span></p>\n\t\t\t\t<Button class="btn btn-red" style="margin: 0px;" onClick="window.open(\'' + data.html_url + '\', \'_blank\')">View Profile</button>\n\t\t\t</div>\n\t\t';
	}

	function stackData(data) {
		return '\n\t\t\t<div class="col-12">\n\t\t\t\t<div class="card-heading">StackExchange Data</div>\n\t\t\t\t<div class="mb-10 well">\n\t\t\t\t\t' + data.items[0].site_name + ' : <span style="color: black">' + data.items[0].reputation + ' Reputation</span>\n\t\t\t\t\t<div>Gold: <span style="color: #ffc107;">' + data.items[0].badge_counts.gold + '</span>, Silver: <span style="color: #bdbdbd;">' + data.items[0].badge_counts.silver + '</span>, Bronze: <span style="color: #cd7f32;">' + data.items[0].badge_counts.bronze + '</span></div>\n\t\t\t\t</div>\n\t\t\t\t<div class="mb-10 well">\n\t\t\t\t\t' + data.items[6].site_name + ' : <span style="color: black">' + data.items[6].reputation + ' Reputation</span>\n\t\t\t\t\t<div>Gold: <span style="color: #ffc107;">' + data.items[6].badge_counts.gold + '</span>, Silver: <span style="color: #bdbdbd;">' + data.items[6].badge_counts.silver + '</span>, Bronze: <span style="color: #cd7f32;">' + data.items[6].badge_counts.bronze + '</span></div>\n\t\t\t\t</div>\n\t\t\t\t<div class="mb-10 well">\n\t\t\t\t\t' + data.items[8].site_name + ' : <span style="color: black">' + data.items[8].reputation + ' Reputation</span>\n\t\t\t\t\t<div>Gold: <span style="color: #ffc107;">' + data.items[8].badge_counts.gold + '</span>, Silver: <span style="color: #bdbdbd;">' + data.items[8].badge_counts.silver + '</span>, Bronze: <span style="color: #cd7f32;">' + data.items[8].badge_counts.bronze + '</span></div>\n\t\t\t\t</div>\n\t\t\t</div>\n\t\t';
	}

	if (document.readyState === "complete") {
		var fadeUp = document.querySelectorAll(".fadeup-anim");
		var modalBtn = document.querySelectorAll('.btn-modal');
		var githubData = document.querySelector('.github-data');
		var stackexchangeData = document.querySelector('.stack-data');
		var offsetTopEl = document.querySelectorAll('.offsetTop');
		var modalClose = document.querySelector('.modal-close');
		var modal = document.querySelector('.modal-container');

		var fadeEL = document.querySelectorAll(".fadeup-anim");
		fadeEL.forEach(function (fadeEL) {
			fadeEL.style.opacity = 0;
		});

		modalClose.addEventListener('click', function (e) {
			hideOverlay();
			modal.innerHTML = '';
		});

		offsetTopEl.forEach(function (offsetTopEl) {
			window.addEventListener("scroll", function () {
				var windowHeight = window.innerHeight,
				    scroll = window.scrollY;
				var eloffset = windowHeight + scroll - 100;

				if (eloffset > offsetTopEl.offsetTop) {
					if (offsetTopEl.classList.contains("fadeup-anim")) {
						if (!offsetTopEl.classList.contains("animated")) {
							offsetTopEl.classList.add("fadeUp", "animated");
						}
					} else if (offsetTopEl.classList.contains("github-data")) {
						if (!offsetTopEl.classList.contains("github-data-retrived")) {
							var git = new XMLHttpRequest();
							git.open('GET', 'https://api.github.com/users/raajnadar');
							git.onload = function () {
								var gitRetData = JSON.parse(git.responseText);
								githubData.innerHTML = gitData(gitRetData);
							};
							git.send();
							offsetTopEl.classList.add("github-data-retrived");
						}
					} else if (offsetTopEl.classList.contains("stack-data")) {
						if (!offsetTopEl.classList.contains("stack-data-retrived")) {
							var stack = new XMLHttpRequest();
							stack.open('GET', 'https://api.stackexchange.com/2.2/users/7233978/associated');
							stack.onload = function () {
								var stackRetData = JSON.parse(stack.responseText);
								stackexchangeData.innerHTML = stackData(stackRetData);
							};
							stack.send();
							offsetTopEl.classList.add("stack-data-retrived");
						}
					}
				}
			});
		});

		modalBtn.forEach(function (modalBtn) {
			modalBtn.addEventListener('click', function (e) {
				showOverlay();
				var dataName = e.target.getAttribute("data-name");
				modal = document.querySelector('.modal-container');

				var req = new XMLHttpRequest();
				req.open('GET', document.baseURI + '/project.json');
				req.onload = function () {
					var data = JSON.parse(req.responseText),
					    index;

					if (modal.innerHTML === '') {
						for (var i = 0; i < data.length; i++) {
							if (data[i].id == dataName) {
								index = i;
							}
						}

						var htmlData = '<div class="modal">\n\t\t\t\t\t\t\t  ' + addElement('head', data, index, data[index].name) + '\n\t\t\t\t\t\t\t  <div class="modal-body">\n\t\t\t\t\t\t\t\t<div class="content">\n\t\t\t\t\t\t\t\t  <div class="row">\n\t\t\t\t\t\t\t\t\t  <div class="col-6 col-offset-3">\n\t\t\t\t\t\t\t\t\t\t  <img class="img-fluid" alt="' + data[index].id + '" src="' + data[index].thumb + '" />\n\t\t\t\t\t\t\t\t\t  </div>\n\t\t\t\t\t\t\t\t  </div>\n\t\t\t\t\t\t\t\t  <div class="align-center">\n\t\t\t\t\t\t\t\t\t  <h3>' + data[index].name + '</h3>\n\t\t\t\t\t\t\t\t  </div>\n\t\t\t\t\t\t\t\t  <p class="mt-10 mb-10"><span style="color: black">Author : </span><a class="link-red" href="' + data[index].author_url + '">' + data[index].author + '</a></p>\n\t\t\t\t\t\t\t\t  <p class="mb-10"><span style="color: black">About project : </span>' + data[index].description + '</p>\n\t\t\t\t\t\t\t\t  <p><span style="color: black">Project repository: </span><a href="' + data[index].project_url + '" target="_blank">' + data[index].project_url + '</a></p>\n\t\t\t\t\t\t\t\t</div>\n\t\t\t\t\t\t\t  </div>\n\t\t\t\t\t\t\t  ' + addElement('foot', data, index, data[index].demo_url) + '\n\t\t\t\t\t\t  </div>';

						modal.innerHTML = htmlData;

						modalClose = document.querySelector('.modal-close');

						modalClose.addEventListener('click', function (e) {
							hideOverlay();
							modal.innerHTML = '';
						});
					}
				};
				req.send();
			});
		});
	}
};

/***/ }),
/* 1 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// js/bundle.js